import app from 'flarum/forum/app';

/**
 * 添加回到顶部按钮
 * 当用户滚动超过一定距离时显示按钮，点击可平滑滚动到页面顶部
 */
export default function addBackToTop() {
  let buttonElement: HTMLElement | null = null;
  let scrollHandler: (() => void) | null = null;

  // 创建按钮元素
  function createButton() {
    if (buttonElement) return;

    buttonElement = document.createElement('div');
    buttonElement.className = 'BackToTop';
    buttonElement.innerHTML = `
      <button class="Button Button--icon BackToTop-button" title="${app.translator.trans('laya-engine-version.forum.back_to_top')}">
        <i class="fas fa-arrow-up"></i>
      </button>
    `;

    buttonElement.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });

    document.body.appendChild(buttonElement);
  }

  // 滚动处理函数
  function handleScroll() {
    if (!buttonElement) return;

    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    if (scrollTop > 300) {
      buttonElement.classList.add('BackToTop--visible');
    } else {
      buttonElement.classList.remove('BackToTop--visible');
    }
  }

  // 初始化
  document.addEventListener('DOMContentLoaded', () => {
    createButton();

    scrollHandler = handleScroll;
    window.addEventListener('scroll', scrollHandler, { passive: true });

    // 初始检查
    handleScroll();
  });

  // 如果 DOM 已经加载完成
  if (document.readyState !== 'loading') {
    createButton();

    scrollHandler = handleScroll;
    window.addEventListener('scroll', scrollHandler, { passive: true });

    // 初始检查
    handleScroll();
  }
}
